import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RseQuestion, RseQuestionsGroup , Supplier} from '../../../../all-models';
import { SupplierRseAnswers } from '../SupplierRseAnswers';
import { ControlContainer, FormGroup, NgForm } from '@angular/forms';
import { SharedDataService } from '../../../../all-services';

@Component({
  selector: 'app-supplier-rse-qst-group',
  templateUrl: './supplier-rse-qst-group.component.html',
  styleUrls: ['./supplier-rse-qst-group.component.scss'],
  viewProviders:[{ provide: ControlContainer, useExisting: NgForm }]
})
export class SupplierRseQstGroupComponent implements OnInit {

  constructor(public sharedDatasSvc:SharedDataService) { }
  
  @Input() supplierAnswsers!:SupplierRseAnswers;
  @Input() rseGroup!:RseQuestionsGroup;
  @Input() readonly: boolean = true;
  @Input() frmRse: NgForm;
  ngOnInit(): void {
  }


  get groupLabelCod(): string {
    if (!this.rseGroup) return '';
    if (this.rseGroup.LblCod) return this.rseGroup.LblCod;
    if ((this.visibleGrpQuestions||[]).length>0) {
      return this.visibleGrpQuestions[0].LblCod;
    }
    return '';
  }

  get visibleGrpQuestions():RseQuestion[] | undefined{
    if (!this.rseGroup || !this.supplierAnswsers.rseQuestions) return undefined;
    let qsts: RseQuestion[]= this.supplierAnswsers.rseQuestions.filter(q=>q.GroupId==this.rseGroup.Id && this.groupOrQuestionIsVisible(q));
    qsts.sortObject('DisplayRank');
    return qsts;
  }


  groupOrQuestionIsVisible(item:RseQuestionsGroup | RseQuestion):boolean {
    if (item.ConditionalQuestionId !=null && item.ConditionalQuestionValue != null){
      return this.supplierAnswsers.supplier.SupplierRseAnswers.some( a=>a.QuestionId==item.ConditionalQuestionId && a.Answer==item.ConditionalQuestionValue);
    } else {
      return true;
    }
  }
  

  get visibleSubGroups():RseQuestionsGroup[] {
      if (!this.rseGroup || !this.supplierAnswsers.rseGroups || !this.supplierAnswsers.supplier?.SupplierRseAnswers) return [];
      return this.supplierAnswsers.rseGroups.filter(g=>{
        if (g.ParentGroupId!=this.rseGroup.Id) return false;
        return this.groupOrQuestionIsVisible(g);
      });
  }
  
}
